"use client";
import React from "react";
import mobile from "@/public/images/phoneContact.svg";
import emailContact from "@/public/images/emailContact.svg";
import locationIcon from "@/public/images/locationB.svg";
import website from "@/public/images/website.svg";
import Image from "next/image";
import { useTranslate } from "@/components/base/providers/TranslateProv";
import { Faculty } from "@/types/Faculty";
import { ChevronLeft } from "lucide-react";

interface LocationProps {
  item: Faculty;
}

const Location: React.FC<LocationProps> = ({ item }) => {
  const { locale } = useTranslate() as { locale: "ar" | "en" };
  const titles = {
    mapTitle:
      locale === "ar" ? "موقع الكليه في الخريطة" : "Faculty Location on Map",
    phoneTitle: locale === "ar" ? "خط الاتصال" : "Contact Number",
    emailTitle: locale === "ar" ? "عنوان البريدي" : "Email Address",
    locationTitle: locale === "ar" ? "الموقع" : "Location",
    websiteTitle: locale === "ar" ? "الموقع الإلكتروني" : "Website",
  };
  console.log({ map_links: item.university.map_links });

  return (
    <>
      <p className="text-25 text-[#141522] font-[600] text-center mb-10">
        {titles.mapTitle}
      </p>
      <div className="w-full flex flex-col items-start justify-center gap-3">
        <div className="flex w-full items-start flex-col gap-3 min-w-[calc(50%-10px)] grow p-5 border border-[#EBEBEB] rounded-[10px]">
          <div className="flex items-center gap-3">
            <div className="min-w-[96px] h-[96px] bg-[#F8F9FA] rounded-[10px] flex items-center justify-center border border-[#EBEBEB]">
              <Image src={locationIcon} alt={`location`} />
            </div>
            <div>
              <p className="text-20 text-darkText mb-5 text-nowrap">
                {locale === "ar" ? "الفرع الحالي" : "Current Branch"}
              </p>
              <p className="text-16 text-descriptionText">
                {item.university.map_links &&
                  item.university.map_links[0]?.title[locale]}
              </p>
            </div>
          </div>
          <iframe
            src={
              item.university.map_links && item.university.map_links[0]?.link
            }
            className="w-full min-h-[350px] max-h-[350px] rounded-[10px]"
            allowFullScreen={false}
          />
        </div>
      </div>
      {item.university.map_links && (
        <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-5">
          {item.university.map_links?.map(
            (map: any, index: any) =>
              index > 0 &&
              map.type == "map" && (
                <a
                  href={map.link}
                  key={index}
                  target="_blank"
                  className="flex items-center justify-between gap-3 w-full p-5 border border-[#EBEBEB] rounded-[10px]"
                >
                  <div className="flex items-center gap-3 justify-center">
                    <div className="w-[96px] h-[96px] min-w-[96px] min-h-[96px] bg-[#F8F9FA] rounded-[10px] flex items-center justify-center border border-[#EBEBEB]">
                      <Image src={locationIcon} alt={`location-${index}`} />
                    </div>
                    <div>
                      <p className="text-20 text-darkText mb-5">
                        {titles.locationTitle} {index + 1}
                      </p>
                      <p className="text-16 text-descriptionText">
                        {map.title[locale]}
                      </p>
                    </div>
                  </div>

                  <a href={map.link} target="_blank" className="font-[400]">
                    <ChevronLeft width={20} height={20} />
                  </a>
                </a>
              )
          )}
        </div>
      )}

      <div className="flex flex-wrap gap-5">
        <div className="flex items-center gap-3 min-w-[calc(50%-10px)] grow p-5 border border-[#EBEBEB] rounded-[10px]">
          <div className="w-[96px] h-[96px] min-w-[96px] min-h-[96px] bg-[#F8F9FA] rounded-[10px] flex items-center justify-center border border-[#EBEBEB]">
            <Image src={mobile} alt="mobile" />
          </div>
          <div>
            <p className="text-20 text-darkText mb-5">{titles.phoneTitle}</p>
            <p className="text-16 text-descriptionText">
              {item.university.phone_number}
            </p>
          </div>
        </div>

        {item.website_url && (
          <div className="flex items-center gap-3 min-w-[calc(50%-10px)] grow p-5 border border-[#EBEBEB] rounded-[10px]">
            <div className="w-[96px] h-[96px] min-w-[96px] min-h-[96px] bg-[#F8F9FA] rounded-[10px] flex items-center justify-center border border-[#EBEBEB]">
              <Image src={website} alt="website" />
            </div>
            <div>
              <p className="text-20 text-darkText mb-5">
                {titles.websiteTitle}
              </p>
              <p className="text-16 text-descriptionText">
                <a href={item.website_url}>{item.website_url}</a>
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Location;
